import { useCallback, useEffect, useState } from "react";
import adminApi from "../api/adminApi";

export function useAdminLocales({ adminToken, enabled }) {
  const [localesList, setLocalesList] = useState([]);
  const [localeLang, setLocaleLang] = useState("ru");
  const [localeData, setLocaleData] = useState({});
  const [localeInitialData, setLocaleInitialData] = useState({});
  const [localeSaving, setLocaleSaving] = useState(false);
  const [localeDirty, setLocaleDirty] = useState(false);

  const loadLocalesList = useCallback(async (token = adminToken) => {
    if (!token) return;
    try {
      const res = await adminApi.getLocalesList(token);
      const list = Array.isArray(res.data?.locales) ? res.data.locales : [];
      setLocalesList(list);
      if (list.length > 0 && !list.includes(localeLang)) {
        setLocaleLang(list[0]);
      }
    } catch (error) {
      console.error("Ошибка загрузки списка локалей:", error);
    }
  }, [adminToken, localeLang]);

  const loadLocale = useCallback(async (token = adminToken, lang = localeLang) => {
    if (!token || !lang) return;
    try {
      const res = await adminApi.getLocale(token, lang);
      const nextData = res.data?.data || {};
      setLocaleData(nextData);
      setLocaleInitialData(nextData);
      setLocaleDirty(false);
    } catch (error) {
      console.error("Ошибка загрузки локали:", error);
    }
  }, [adminToken, localeLang]);

  const updateLocaleData = useCallback((nextData) => {
    setLocaleData(nextData);
    setLocaleDirty(JSON.stringify(nextData) !== JSON.stringify(localeInitialData));
  }, [localeInitialData]);

  const saveLocale = useCallback(async () => {
    if (!adminToken || !localeLang) return;
    setLocaleSaving(true);
    try {
      await adminApi.updateLocale(adminToken, localeLang, localeData);
      setLocaleInitialData(localeData);
      setLocaleDirty(false);
    } catch (error) {
      console.error("Ошибка сохранения локали:", error);
      window.alert("Ошибка сохранения локали");
    } finally {
      setLocaleSaving(false);
    }
  }, [adminToken, localeLang, localeData]);

  useEffect(() => {
    if (!enabled || !adminToken) return;
    loadLocalesList(adminToken);
  }, [enabled, adminToken, loadLocalesList]);

  useEffect(() => {
    if (!enabled || !adminToken || !localeLang) return;
    loadLocale(adminToken, localeLang);
  }, [enabled, adminToken, localeLang, loadLocale]);

  return {
    state: {
      localesList,
      localeLang,
      localeData,
      localeInitialData,
      localeSaving,
      localeDirty
    },
    actions: {
      setLocaleLang,
      setLocaleData: updateLocaleData,
      reload: () => loadLocale(adminToken, localeLang),
      save: saveLocale,
      loadLocalesList
    }
  };
}

export default useAdminLocales;
